/* MV Sortiment assets/mv-sortiment.teile.js - Paket E-T - 2026-10-07
 *
 * Ersatzteile und Zubehoer (Inhaber 06.10.2026: "Bau auch noch so eine Ersatzteil Sektion in geil").
 *  1. Kollektionsseite sections/mv-ersatzteile.liquid ([data-mv-ersatzteile]): Filter "Mein Automat" (Chips
 *     [data-mv-teile-automat]), Kacheln nach Aufgabe ([data-mv-teile-kategorie] mit [data-mv-teile-kategorien]) und
 *     Live-Suche ([data-mv-teile-suche]) ueber die Karten [data-mv-teil] aus snippets/mv-produktkarte.liquid
 *     (teile: true; data-mv-teil-passt, data-mv-teil-kategorie, data-mv-teil-such). Die Zelle
 *     [data-mv-teile-zelle] bekommt hidden. Zaehler je Chip (Kategorie und Suche wirken, die Familie nicht) und je
 *     Kachel (Familie und Suche wirken, die Kachel nicht), Status mit aria-live, Auswahl-Leiste, Leerzustand mit
 *     Lightbox-Oeffner (data-konfiguration), Hinweis auf Teile ohne Angabe zur Baureihe.
 *     URL-Vertrag: ?automat=<familie> &kategorie=<kachel oder kategorie> &q=<suche>, per history.replaceState;
 *     fremde Parameter (sort_by, preview_theme_id) bleiben, der Hash bleibt hinten. Startwerte: URL, dann die
 *     Tag-Seite (data-mv-teile-start-*), dann localStorage['mv-mein-automat'] = {"v":1,"automat":"<familie>"}.
 *     Auf Tag-Seiten (data-mv-teile-gefiltert, Liste serverseitig gefiltert) bleiben Chips und Kacheln Links.
 *     Links mit Strg/Cmd/Umschalt/Alt oder Mittelklick bleiben Links (neuer Tab).
 *  2. Bestell-Eigenschaften snippets/mv-eigenschaften.liquid ([data-mv-eigenschaften="<form-id>"]): Vorbelegung aus
 *     ?eig_<name>=<wert> (Vertrag Spiralen-Berater, Paket E-B; Name ohne Umlaut-Unterschied), Auswahl per exaktem,
 *     gelockertem oder Praefix-Treffer, sonst als markierte eigene Option; Pflichtfelder: das invalid-Ereignis
 *     (Impacts product-form prueft vor dem Absenden) zeigt die Meldung am Feld statt der Browser-Blase und setzt
 *     den Fokus; Werte ueberstehen ein Neurendern der Kaufbox (product:rerender).
 * Paket T-1 (2026-10-07, Querpruefung R-1, Abschnitt 5): "Filter entfernen", "Alle Filter zuruecksetzen" und "Alle
 *     Teile zeigen" verschwinden mit ihrem Filter; der Fokus springt dann auf den naechsten Entfernen-Knopf der
 *     Auswahl-Leiste, sonst auf den Ergebnistitel [data-mv-teile-titel] (preventScroll; reine Logik
 *     fokusNachEntfernen).
 *  3. Paket EP-3 (2026-11-02, _docs/ep3-nummernsuche.md; Inhaber 02.11.2026: noch nicht angelegte Teile ueber die
 *     Artikelnummer zugaenglich machen): Nummernsuche in der SandenVendo-Ersatzteil-Preisliste. Hat die Suche
 *     [data-mv-teile-suche] getrimmt 3 bis 60 Zeichen, fragt das Skript - entprellt 350 ms, die laufende Anfrage
 *     abgebrochen, die Antwort je Eingabe im Speicher (hoechstens 50) - GET <basis>/teil?q=<q> (App-Proxy, oeffentliche
 *     Route; basis aus [data-mv-nummer-basis], sonst /apps/mv wie mv-sortiment.konto.js; credentials same-origin, Accept
 *     application/json). Die Antwort (Vertrag: Plan docs/mv-vending/sortiment/planung/
 *     plan-ersatzteil-preisliste-2026-11-02.md Abschnitt 6) fuellt die Gruppe [data-mv-nummer-gruppe]: Karten aus
 *     template[data-mv-nummer-karte], nur per textContent und Attributen (nie innerHTML), Zaehler mit Suchbegriff im Kopf
 *     ([data-mv-nummer-q]: "N Treffer fuer <q>"), Ansage fuer Screenreader in [data-mv-nummer-ansage] (Titel und
 *     [data-mv-nummer-anzahl] ohne Suchbegriff, "Ersatzteilsuche: N Treffer"; role=status ausserhalb der verborgenen
 *     Gruppe; erst nach dem Zeigen gesetzt, beim Verbergen geleert), Zeile "weitere", Hinweis ohne Treffer. Benennung
 *     "Ersatzteilsuche" (Inhaber 03.11.2026) steht nur in der Sektion. ok false, HTTP != 200 oder kein JSON
 *     (Proxy fehlt): Gruppe verborgen, hoechstens einmal console.warn. ?q= beim Laden sucht einmal; Enter sucht sofort;
 *     Escape, Suche leeren und Filter zuruecksetzen verbergen die Gruppe. Das Formular [data-mv-nummer-form] im Band setzt
 *     das Suchfeld, sucht sofort und setzt danach den Fokus auf den Gruppenkopf [data-mv-nummer-titel] (ohne Antwort:
 *     Ergebnistitel).
 *     Kartenfilter, URL-Vertrag (?q=) und Speicher bleiben wie bisher.
 * Delegation auf document; Theme-Editor (shopify:section:load) und bfcache (pageshow) zeichnen neu.
 * Teil von assets/mv-sortiment.js (_build/konkat.sh), laedt allein und in beliebiger Reihenfolge, defer-faehig.
 * Unter Node (Tests) liefert die Datei nur die reinen Funktionen ueber module.exports.
 * Kommentare ASCII; sichtbare Texte als \u-Escapes, damit die Datei unabhaengig vom Zeichensatz bleibt.
 */
;(function () {
  'use strict';

  var VERSION = '2026-11-02.1';
  var SPEICHER = 'mv-mein-automat';
  var KENNUNG = /^[a-z0-9][a-z0-9-]*$/;
  var MAX_SUCHE = 80;
  var MAX_WORTE = 8;
  var MAX_WERT = 200;

  var TEXT = {
    teil: 'Teil',
    teile: 'Teile',
    fuer: ' f\u00fcr ',
    trenner: ' \u00b7 ',
    sucheVor: 'Suche \u201e',
    sucheNach: '\u201c',
    automat: 'Automat: ',
    aufgabe: 'Aufgabe: ',
    suche: 'Suche: ',
    anfrage: 'Ersatzteil-Anfrage',
    ohneEins: 'Ein weiteres Teil hat keine Angabe zur Baureihe.',
    ohneVor: 'Weitere ',
    ohneNach: ' Teile haben keine Angabe zur Baureihe.',
    ausLink: ' (aus Ihrem Link)'
  };

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  // Suchform: klein, Umlaute wie ihre Umschreibung (ae, oe, ue) und beide wie der Grundbuchstabe, ss und \u00df wie
  // s, Akzente weg, nur a-z und Ziffern, Leerraum zusammengefasst. "K\u00fchlung", "Kuehlung" und "Kuhlung" ergeben
  // dasselbe; die Regel gilt fuer Text und Eingabe gleich, Treffer gehen also nie verloren.
  function normalisiere(text) {
    var s = String(text === null || text === undefined ? '' : text).toLowerCase();
    s = s.replace(/\u00e4/g, 'a').replace(/\u00f6/g, 'o').replace(/\u00fc/g, 'u').replace(/\u00df/g, 's');
    if (typeof s.normalize === 'function') s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    s = s.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u').replace(/s+/g, 's');
    return s.replace(/[^a-z0-9]+/g, ' ').replace(/^ +| +$/g, '');
  }

  function kompakt(text) {
    return normalisiere(text).replace(/ /g, '');
  }

  // Suchwoerter der Eingabe: normalisiert, ohne Dubletten, hoechstens MAX_WORTE
  function begriffe(eingabe) {
    var aus = [];
    normalisiere(String(eingabe === null || eingabe === undefined ? '' : eingabe).slice(0, MAX_SUCHE)).split(' ').forEach(function (w) {
      if (w && aus.indexOf(w) === -1 && aus.length < MAX_WORTE) aus.push(w);
    });
    return aus;
  }

  // Suchtext einer Karte (data-mv-teil-such) einmal vorbereiten
  function suchEintrag(roh) {
    var t = normalisiere(roh);
    return { text: ' ' + t + ' ', kompakt: t.replace(/ /g, '') };
  }

  // Treffer: jedes Wort steht im Text oder in der Kompaktform (Teilwort genuegt); die ganze Eingabe ohne
  // Leerzeichen in der Kompaktform genuegt ab drei Zeichen ebenfalls (Artikelnummern wie 407852/1 oder 407 852 1)
  function passtSuche(eintrag, eingabe) {
    var w = begriffe(eingabe);
    if (!w.length) return true;
    if (!eintrag) return false;
    var ganz = w.join('');
    if (ganz.length >= 3 && eintrag.kompakt.indexOf(ganz) !== -1) return true;
    for (var i = 0; i < w.length; i++) {
      if (eintrag.text.indexOf(w[i]) === -1 && eintrag.kompakt.indexOf(w[i]) === -1) return false;
    }
    return true;
  }

  // Familie: ohne Auswahl passt jedes Teil; passt:alle passt zu jeder Familie
  function passtAutomat(passt, automat) {
    if (!automat) return true;
    var liste = passt || [];
    return liste.indexOf(automat) !== -1 || liste.indexOf('alle') !== -1;
  }

  function passtKategorie(kategorien, gesucht) {
    if (!gesucht || !gesucht.length) return true;
    var liste = kategorien || [];
    for (var i = 0; i < gesucht.length; i++) if (liste.indexOf(gesucht[i]) !== -1) return true;
    return false;
  }

  // Kategorien zu einem Schluessel: Kachel (bestuecken -> spiralen-ausgabe, spacer) oder eine einzelne Kategorie
  function kategorienVon(schluessel, karte) {
    if (!schluessel || !karte) return [];
    if (Object.prototype.hasOwnProperty.call(karte, schluessel)) return karte[schluessel].slice();
    for (var k in karte) {
      if (Object.prototype.hasOwnProperty.call(karte, k) && karte[k].indexOf(schluessel) !== -1) return [schluessel];
    }
    return [];
  }

  // Kachel zu einem Schluessel (Kachel selbst oder die Kachel, zu der die Kategorie gehoert)
  function kachelVon(schluessel, karte) {
    if (!schluessel || !karte) return '';
    if (Object.prototype.hasOwnProperty.call(karte, schluessel)) return schluessel;
    for (var k in karte) {
      if (Object.prototype.hasOwnProperty.call(karte, k) && karte[k].indexOf(schluessel) !== -1) return k;
    }
    return '';
  }

  function sichtbar(teil, zustand, karte) {
    var z = zustand || {};
    return passtAutomat(teil.passt, z.automat) && passtKategorie(teil.kategorien, kategorienVon(z.kategorie, karte)) && passtSuche(teil.suche, z.q);
  }

  // Zaehler: je Familie (ohne den Familienfilter), je Kachel (ohne den Kachelfilter), Treffer gesamt und Teile, die
  // nur fehlen, weil sie keine Familie tragen
  function zaehlen(teile, zustand, karte, familien) {
    var z = zustand || {};
    var gesucht = kategorienVon(z.kategorie, karte);
    var aus = { alle: 0, familien: {}, kacheln: {}, treffer: 0, ohneFamilie: 0 };
    (familien || []).forEach(function (f) { aus.familien[f] = 0; });
    for (var k in karte) if (Object.prototype.hasOwnProperty.call(karte, k)) aus.kacheln[k] = 0;
    (teile || []).forEach(function (t) {
      var such = passtSuche(t.suche, z.q);
      if (!such) return;
      var kat = passtKategorie(t.kategorien, gesucht);
      var fam = passtAutomat(t.passt, z.automat);
      if (kat) {
        aus.alle += 1;
        for (var f in aus.familien) if (Object.prototype.hasOwnProperty.call(aus.familien, f) && passtAutomat(t.passt, f)) aus.familien[f] += 1;
        if (fam) aus.treffer += 1;
        else if (!(t.passt || []).length) aus.ohneFamilie += 1;
      }
      if (fam) {
        for (var kk in aus.kacheln) if (Object.prototype.hasOwnProperty.call(aus.kacheln, kk) && passtKategorie(t.kategorien, karte[kk])) aus.kacheln[kk] += 1;
      }
    });
    return aus;
  }

  // Wert eines Query-Parameters (null, wenn er fehlt); ohne URLSearchParams, damit Node und Browser gleich rechnen
  function parameter(suche, name) {
    var s = String(suche || '');
    if (s.charAt(0) === '?') s = s.slice(1);
    var paare = s.split('&');
    for (var i = 0; i < paare.length; i++) {
      if (!paare[i]) continue;
      var gleich = paare[i].indexOf('=');
      var k = gleich === -1 ? paare[i] : paare[i].slice(0, gleich);
      var v = gleich === -1 ? '' : paare[i].slice(gleich + 1);
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
        v = decodeURIComponent(v.replace(/\+/g, ' '));
      } catch (e) {
        continue;
      }
      if (k === name) return v;
    }
    return null;
  }

  // Zustand aus der URL: nur bekannte Familien und Kachel- bzw. Kategorie-Schluessel; Suche gekuerzt
  function zustandAusSuche(suche, gueltig) {
    var g = gueltig || {};
    var automat = String(parameter(suche, 'automat') || '').toLowerCase();
    var kategorie = String(parameter(suche, 'kategorie') || '').toLowerCase();
    var q = String(parameter(suche, 'q') || '').replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, MAX_SUCHE);
    return {
      automat: KENNUNG.test(automat) && (g.familien || []).indexOf(automat) !== -1 ? automat : '',
      kategorie: KENNUNG.test(kategorie) && kachelVon(kategorie, g.karte) ? kategorie : '',
      q: q
    };
  }

  // href mit dem Zustand: automat, kategorie und q gesetzt bzw. entfernt, andere Parameter bleiben in ihrer
  // Reihenfolge, der Hash bleibt hinten
  function urlMitZustand(href, zustand) {
    var z = zustand || {};
    var s = String(href || '');
    var hash = '';
    var h = s.indexOf('#');
    if (h !== -1) {
      hash = s.slice(h);
      s = s.slice(0, h);
    }
    var q = s.indexOf('?');
    var pfad = q === -1 ? s : s.slice(0, q);
    var teile = q === -1 ? [] : s.slice(q + 1).split('&').filter(function (p) {
      var name = p.split('=')[0];
      return p && name !== 'automat' && name !== 'kategorie' && name !== 'q';
    });
    if (z.automat) teile.push('automat=' + encodeURIComponent(z.automat));
    if (z.kategorie) teile.push('kategorie=' + encodeURIComponent(z.kategorie));
    if (z.q) teile.push('q=' + encodeURIComponent(z.q));
    return pfad + (teile.length ? '?' + teile.join('&') : '') + hash;
  }

  // Speicher {"v":1,"automat":"<familie>"}: lesen (nur gueltige Familien) und schreiben (leer = entfernen)
  function speicherLesen(text, familien) {
    var d = null;
    try {
      d = JSON.parse(text || 'null');
    } catch (e) {
      return '';
    }
    var a = d && d.v === 1 && typeof d.automat === 'string' ? d.automat : '';
    return KENNUNG.test(a) && (familien || []).indexOf(a) !== -1 ? a : '';
  }

  function speicherWert(automat) {
    return automat ? JSON.stringify({ v: 1, automat: automat }) : null;
  }

  // Statuszeile: "12 Teile fuer G-Drink . Bestuecken . Suche ..."
  function statusText(n, labels) {
    var l = labels || {};
    var t = String(n) + ' ' + (n === 1 ? TEXT.teil : TEXT.teile);
    if (l.automat) t += TEXT.fuer + l.automat;
    if (l.kachel) t += TEXT.trenner + l.kachel;
    if (l.q) t += TEXT.trenner + TEXT.sucheVor + l.q + TEXT.sucheNach;
    return t;
  }

  // data-konfiguration der Anfrage: Angaben mit Mittelpunkt (Format der Lightbox)
  function anfrageText(labels) {
    var l = labels || {};
    var teile = [TEXT.anfrage];
    if (l.automat) teile.push(TEXT.automat + l.automat);
    if (l.kachel) teile.push(TEXT.aufgabe + l.kachel);
    if (l.q) teile.push(TEXT.suche + l.q);
    return teile.join(TEXT.trenner);
  }

  function ohneText(n) {
    if (n <= 0) return '';
    return n === 1 ? TEXT.ohneEins : TEXT.ohneVor + n + TEXT.ohneNach;
  }

  // eig_<name>=<wert> aus der Suche; Werte gekuerzt, leere entfallen, Reihenfolge der URL
  function eigenschaftenAusSuche(suche) {
    var s = String(suche || '');
    if (s.charAt(0) === '?') s = s.slice(1);
    var aus = [];
    s.split('&').forEach(function (paar) {
      if (!paar) return;
      var gleich = paar.indexOf('=');
      var k = gleich === -1 ? paar : paar.slice(0, gleich);
      var v = gleich === -1 ? '' : paar.slice(gleich + 1);
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
        v = decodeURIComponent(v.replace(/\+/g, ' '));
      } catch (e) {
        return;
      }
      if (k.slice(0, 4) !== 'eig_') return;
      var name = k.slice(4);
      var wert = v.replace(/[\u0000-\u001f\u007f]/g, '').replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, MAX_WERT);
      if (name && wert) aus.push({ name: name, wert: wert });
    });
    return aus;
  }

  // Name einer Eigenschaft ohne Umlaut- und Schreibunterschied (Ganghoehe = Gangh\u00f6he = GANGHOEHE)
  function nameGleich(a, b) {
    var x = kompakt(a);
    return x !== '' && x === kompakt(b);
  }

  // Option zu einem Wert: exakt, dann gelockert (normalisiert gleich), dann eindeutiger Praefix-Treffer
  // ("links" -> "links (Standard)"); -1, wenn nichts passt. optionen: Liste der Optionstexte ohne Platzhalter.
  function optionIndex(optionen, wert) {
    var liste = optionen || [];
    var w = String(wert || '').replace(/^\s+|\s+$/g, '');
    if (!w) return -1;
    var i;
    for (i = 0; i < liste.length; i++) if (String(liste[i]) === w) return i;
    var n = normalisiere(w);
    for (i = 0; i < liste.length; i++) if (normalisiere(liste[i]) === n) return i;
    var treffer = -1;
    for (i = 0; i < liste.length; i++) {
      var o = normalisiere(liste[i]);
      if (n && o.indexOf(n + ' ') === 0) {
        if (treffer !== -1) return -1;
        treffer = i;
      }
    }
    return treffer;
  }

  // Fokus nach dem Entfernen eines Filters (Paket T-1, WCAG 2.4.3): Der betaetigte Knopf verschwindet mit seinem
  // Filter. Ziel ist der naechste noch sichtbare Entfernen-Knopf in Leserichtung, sonst der davor, sonst -1 (dann
  // der Ergebnistitel). sichtbar: Sichtbarkeit der Entfernen-Knoepfe der Auswahl-Leiste in Dokumentreihenfolge;
  // index: Stelle des betaetigten Knopfs, -1 fuer Knoepfe ausserhalb der Leiste ("Alle Teile zeigen", Zuruecksetzen).
  function fokusNachEntfernen(sichtbar, index) {
    var liste = Object.prototype.toString.call(sichtbar) === '[object Array]' ? sichtbar : [];
    var start = typeof index === 'number' && index >= 0 ? index : -1;
    var i;
    for (i = start + 1; i < liste.length; i++) if (liste[i]) return i;
    for (i = Math.min(start, liste.length) - 1; i >= 0; i--) if (liste[i]) return i;
    return -1;
  }

  // ---------- Paket EP-3: Nummernsuche in der SandenVendo-Preisliste (reine Logik) ----------

  var NUMMER = { min: 3, max: 60, basis: '/apps/mv', pause: 350, speicher: 50, teilMax: 200, trefferMax: 20 };
  var BASIS_RE = /^(?:\/[a-z0-9_-]+)+$/i;
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/;
  var STAND_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
  var EURO = null;

  // Text einzeilig: Steuerzeichen weg, Leerraum (auch geschuetzter) zu einem Leerzeichen, getrimmt
  function einzeilig(text) {
    return String(text === null || text === undefined ? '' : text).replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').replace(/^ | $/g, '');
  }

  // Eingabe der Nummernsuche: einzeilig; '' ausserhalb von 3 bis 60 Zeichen (Vertrag der Route)
  function nummerFrage(eingabe) {
    var q = einzeilig(eingabe);
    return q.length >= NUMMER.min && q.length <= NUMMER.max ? q : '';
  }

  // Adresse der Route: Basis nur als Pfad (sonst /apps/mv, nie eine fremde Adresse) + /teil?q=
  function nummerUrl(basis, q) {
    var b = typeof basis === 'string' && BASIS_RE.test(basis) ? basis : NUMMER.basis;
    return b + '/teil?q=' + encodeURIComponent(q);
  }

  // Betrag in Euro wie Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }) ("1.100,00", geschuetztes
  // Leerzeichen, Euro-Zeichen); ohne Intl dieselbe Form von Hand
  function euro(betrag) {
    var n = Number(betrag);
    if (typeof betrag !== 'number' || !isFinite(n)) return '';
    if (EURO === null) {
      try {
        EURO = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
      } catch (e) {
        EURO = false;
      }
    }
    if (EURO) return EURO.format(n);
    var cent = Math.round(Math.abs(n) * 100);
    var rest = String(cent % 100);
    return (n < 0 ? '-' : '') + String(Math.floor(cent / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (rest.length < 2 ? '0' + rest : rest) + '\u00a0\u20ac';
  }

  // Stand der Preisliste ('2026-04-01') als Monat/Jahr ('04/2026'); '' in jeder anderen Form
  function standText(stand) {
    var m = STAND_RE.exec(String(stand === null || stand === undefined ? '' : stand));
    return m && m[2] >= '01' && m[2] <= '12' ? m[2] + '/' + m[1] : '';
  }

  // Betrag der Antwort: Zahl > 0, auf Cent gerundet; sonst null (Listenpreis 0 = "Preis auf Anfrage")
  function betragAus(wert) {
    if (typeof wert !== 'number' || !isFinite(wert) || wert <= 0) return null;
    return Math.round(wert * 100) / 100;
  }

  // Shop-Eintrag (im_shop): Handle nach Shopify-Muster, Titel, Preisstatus preis | anfrage; sonst null
  function shopAus(roh) {
    if (!roh || typeof roh !== 'object') return null;
    var handle = typeof roh.handle === 'string' ? roh.handle : '';
    if (!HANDLE_RE.test(handle) || handle.length > 255) return null;
    return { handle: handle, titel: einzeilig(roh.titel).slice(0, 200), sku: einzeilig(roh.sku).slice(0, 80), status: roh.preis_status === 'anfrage' ? 'anfrage' : 'preis' };
  }

  // Ein Treffer der Antwort, vereinheitlicht; ohne Nummer (hoechstens 60 Zeichen) oder Bezeichnung null
  function trefferAus(roh) {
    if (!roh || typeof roh !== 'object') return null;
    var nr = einzeilig(roh.nr);
    var bezeichnung = einzeilig(roh.bezeichnung) || einzeilig(roh.bezeichnung_liste);
    if (!nr || nr.length > NUMMER.max || !bezeichnung) return null;
    var netto = betragAus(roh.preis_netto);
    return {
      nr: nr,
      bezeichnung: bezeichnung.slice(0, 200),
      liste: (einzeilig(roh.bezeichnung_liste) || bezeichnung).slice(0, 200),
      netto: netto,
      brutto: netto === null ? null : betragAus(roh.preis_brutto),
      shop: shopAus(roh.im_shop)
    };
  }

  // Antwort der Route ({ ok: true, stand, q, treffer: [...], weitere }) -> { stand: 'MM/JJJJ' | '', treffer, weitere };
  // ok nicht true oder treffer keine Liste: null
  function antwortAus(json) {
    if (!json || typeof json !== 'object' || json.ok !== true || Object.prototype.toString.call(json.treffer) !== '[object Array]') return null;
    var treffer = [];
    for (var i = 0; i < json.treffer.length && treffer.length < NUMMER.trefferMax; i++) {
      var t = trefferAus(json.treffer[i]);
      if (t) treffer.push(t);
    }
    var weitere = typeof json.weitere === 'number' && isFinite(json.weitere) && json.weitere > 0 ? Math.floor(json.weitere) : 0;
    return { stand: standText(json.stand), treffer: treffer, weitere: weitere };
  }

  // data-teil des Anfrage-Knopfs: "<Nummer> - <Bezeichnung> - <Preis> netto" (Gedankenstrich), einzeilig, hoechstens 200
  // Zeichen; zu lang: die Bezeichnung wird mit Auslassungszeichen gekuerzt, Nummer und Preis bleiben. Ohne Preis nur
  // Nummer und Bezeichnung.
  function anfrageTeil(nr, bezeichnung, netto) {
    var trenner = ' \u2013 ';
    var n = einzeilig(nr).slice(0, NUMMER.max);
    var b = einzeilig(bezeichnung);
    var p = typeof netto === 'number' && netto > 0 ? einzeilig(euro(netto)) + ' netto' : '';
    var platz = NUMMER.teilMax - n.length - (p ? trenner.length + p.length : 0) - trenner.length;
    if (b.length > platz) b = platz > 1 ? b.slice(0, platz - 1).replace(/ +$/, '') + '\u2026' : '';
    var teile = [];
    if (n) teile.push(n);
    if (b) teile.push(b);
    if (p) teile.push(p);
    return teile.join(trenner).slice(0, NUMMER.teilMax);
  }

  // Rueckfall-Adresse des Anfrage-Knopfs (ohne Lightbox-Skript): Kontaktseite mit Interesse, Produkt und Teil
  function anfrageHref(teil) {
    return '/pages/contact?anfrage=1&interesse=Service&produkt=Ersatzteil-Anfrage&teil=' + encodeURIComponent(teil);
  }

  // Speicher der Antworten je Eingabe: hoechstens max Eintraege, der aelteste faellt zuerst heraus
  function nummerSpeicher(max) {
    var reihe = [];
    var werte = {};
    function hat(k) {
      return Object.prototype.hasOwnProperty.call(werte, k);
    }
    return {
      hole: function (q) {
        return hat('#' + q) ? werte['#' + q] : null;
      },
      lege: function (q, wert) {
        var k = '#' + q;
        if (!hat(k)) reihe.push(k);
        werte[k] = wert;
        while (reihe.length > max) delete werte[reihe.shift()];
      },
      groesse: function () {
        return reihe.length;
      }
    };
  }

  var logik = {
    VERSION: VERSION,
    SPEICHER: SPEICHER,
    MAX_SUCHE: MAX_SUCHE,
    normalisiere: normalisiere,
    kompakt: kompakt,
    begriffe: begriffe,
    suchEintrag: suchEintrag,
    passtSuche: passtSuche,
    passtAutomat: passtAutomat,
    passtKategorie: passtKategorie,
    kategorienVon: kategorienVon,
    kachelVon: kachelVon,
    sichtbar: sichtbar,
    zaehlen: zaehlen,
    parameter: parameter,
    zustandAusSuche: zustandAusSuche,
    urlMitZustand: urlMitZustand,
    speicherLesen: speicherLesen,
    speicherWert: speicherWert,
    statusText: statusText,
    anfrageText: anfrageText,
    ohneText: ohneText,
    eigenschaftenAusSuche: eigenschaftenAusSuche,
    nameGleich: nameGleich,
    optionIndex: optionIndex,
    fokusNachEntfernen: fokusNachEntfernen,
    NUMMER: NUMMER,
    einzeilig: einzeilig,
    nummerFrage: nummerFrage,
    nummerUrl: nummerUrl,
    euro: euro,
    standText: standText,
    betragAus: betragAus,
    shopAus: shopAus,
    trefferAus: trefferAus,
    antwortAus: antwortAus,
    anfrageTeil: anfrageTeil,
    anfrageHref: anfrageHref,
    nummerSpeicher: nummerSpeicher
  };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.teile) return;

  function alle(selektor, wurzel) {
    return Array.prototype.slice.call((wurzel || document).querySelectorAll(selektor));
  }

  function attr(el, name) {
    return el ? el.getAttribute(name) || '' : '';
  }

  function liste(text) {
    return String(text || '').split(/\s+/).filter(Boolean);
  }

  function reduziert() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
      return false;
    }
  }

  // Normaler Linksklick ohne Modifier wird abgefangen, sonst bleibt der Link ein Link (neuer Tab)
  function abfangen(e) {
    if (!e || e.defaultPrevented) return false;
    if (e.button !== undefined && e.button !== 0) return false;
    return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
  }

  function speicherHolen() {
    try {
      return window.localStorage.getItem(SPEICHER);
    } catch (e) {
      return null;
    }
  }

  function speicherSetzen(automat) {
    try {
      var w = speicherWert(automat);
      if (w) window.localStorage.setItem(SPEICHER, w);
      else window.localStorage.removeItem(SPEICHER);
    } catch (e) { /* privater Modus, Speicher voll */ }
  }

  // ---------- 1. Ersatzteil-Seite ----------

  var seiten = [];

  function seiteLesen(wurzel) {
    var karte = {};
    var kachelLabel = {};
    alle('[data-mv-teile-kategorie][data-mv-teile-kategorien]', wurzel).forEach(function (k) {
      var key = attr(k, 'data-mv-teile-kategorie');
      if (!KENNUNG.test(key)) return;
      karte[key] = liste(attr(k, 'data-mv-teile-kategorien'));
      kachelLabel[key] = attr(k, 'data-mv-teile-label');
    });
    var familien = [];
    var famLabel = {};
    alle('[data-mv-teile-automat]', wurzel).forEach(function (c) {
      var f = attr(c, 'data-mv-teile-automat');
      if (f && KENNUNG.test(f) && familien.indexOf(f) === -1) {
        familien.push(f);
        famLabel[f] = attr(c, 'data-mv-teile-label') || f;
      }
    });
    var teile = alle('[data-mv-teil]', wurzel).map(function (el) {
      return {
        el: el,
        zelle: el.closest('[data-mv-teile-zelle]') || el,
        passt: liste(attr(el, 'data-mv-teil-passt')),
        kategorien: liste(attr(el, 'data-mv-teil-kategorie')),
        suche: suchEintrag(attr(el, 'data-mv-teil-such'))
      };
    });
    return {
      wurzel: wurzel,
      basis: attr(wurzel, 'data-mv-teile-basis'),
      gefiltert: wurzel.hasAttribute('data-mv-teile-gefiltert'),
      karte: karte,
      kachelLabel: kachelLabel,
      familien: familien,
      famLabel: famLabel,
      teile: teile,
      zustand: { automat: '', kategorie: '', q: '' },
      merkGezeigt: false,
      timer: null
    };
  }

  function labelsVon(s) {
    var k = kachelVon(s.zustand.kategorie, s.karte);
    return {
      automat: s.zustand.automat ? s.famLabel[s.zustand.automat] || s.zustand.automat : '',
      kachel: k ? s.kachelLabel[k] || k : '',
      q: s.zustand.q
    };
  }

  function zahlSetzen(el, n) {
    if (el) el.textContent = String(n);
  }

  function zeichnen(s) {
    var w = s.wurzel;
    var z = s.zustand;
    var zahl = zaehlen(s.teile, z, s.karte, s.familien);
    var aktiveKachel = kachelVon(z.kategorie, s.karte);
    // Links fuer neue Tabs: aktuelle Seite als Basis (sort_by, preview_theme_id bleiben), sonst die Kollektion
    var hier = window.location && window.location.pathname ? window.location.pathname + window.location.search : s.basis;
    s.teile.forEach(function (t) {
      t.zelle.hidden = !sichtbar(t, z, s.karte);
    });

    // Chips "Mein Automat"
    alle('[data-mv-teile-automat]', w).forEach(function (c) {
      var f = attr(c, 'data-mv-teile-automat');
      if (f === z.automat) c.setAttribute('aria-current', 'true');
      else c.removeAttribute('aria-current');
      zahlSetzen(c.querySelector('[data-mv-teile-chip-zahl]'), f ? zahl.familien[f] || 0 : zahl.alle);
      if (!s.gefiltert && hier) c.setAttribute('href', urlMitZustand(hier, { automat: f, kategorie: z.kategorie, q: z.q }));
    });

    // Kacheln
    alle('[data-mv-teile-kategorie][data-mv-teile-kategorien]', w).forEach(function (k) {
      var key = attr(k, 'data-mv-teile-kategorie');
      var n = zahl.kacheln[key] || 0;
      if (key === aktiveKachel) k.setAttribute('aria-current', 'true');
      else k.removeAttribute('aria-current');
      if (n === 0) k.setAttribute('data-leer', '');
      else k.removeAttribute('data-leer');
      zahlSetzen(k.querySelector('[data-mv-teile-zahl]'), n);
      var wort = k.querySelector('[data-mv-teile-wort]');
      if (wort) wort.textContent = n === 1 ? TEXT.teil : TEXT.teile;
      if (!s.gefiltert && hier && k.tagName === 'A') {
        var href = k.getAttribute('href') || '';
        var hash = href.indexOf('#') === -1 ? '' : href.slice(href.indexOf('#'));
        k.setAttribute('href', urlMitZustand(hier + hash, { automat: z.automat, kategorie: key, q: z.q }));
      }
    });

    var labels = labelsVon(s);

    // Status (aria-live) und Auswahl-Leiste
    var status = w.querySelector('[data-mv-teile-status]');
    if (status) {
      var text = statusText(zahl.treffer, labels);
      if (status.textContent.replace(/\s+/g, ' ').replace(/^ | $/g, '') !== text) status.textContent = text;
    }
    var auswahl = w.querySelector('[data-mv-teile-auswahl]');
    if (auswahl) {
      var werte = { automat: labels.automat, kategorie: labels.kachel, q: labels.q ? TEXT.sucheVor + labels.q + TEXT.sucheNach : '' };
      var irgendwas = false;
      alle('[data-mv-teile-auswahl-eintrag]', auswahl).forEach(function (li) {
        var art = attr(li, 'data-mv-teile-auswahl-eintrag');
        var wert = werte[art] || '';
        li.hidden = !wert;
        if (wert) irgendwas = true;
        var t = li.querySelector('[data-mv-teile-auswahl-text]');
        if (t) t.textContent = wert;
      });
      auswahl.hidden = !irgendwas;
    }

    // Leerzustand, Anfrage mit Kontext, Teile ohne Familie
    var leer = w.querySelector('[data-mv-teile-leer]');
    if (leer) leer.hidden = zahl.treffer > 0 || !s.teile.length;
    alle('[data-mv-teile-anfrage]', w).forEach(function (a) {
      a.setAttribute('data-konfiguration', anfrageText(labels));
    });
    var ohne = w.querySelector('[data-mv-teile-ohne]');
    if (ohne) {
      var ot = z.automat && zahl.treffer > 0 ? ohneText(zahl.ohneFamilie) : '';
      ohne.hidden = !ot;
      var otEl = ohne.querySelector('[data-mv-teile-ohne-text]');
      if (otEl) otEl.textContent = ot;
    }

    // Sortier-Links behalten den Zustand
    alle('[data-mv-teile-sortierung]', w).forEach(function (a) {
      a.setAttribute('href', urlMitZustand(a.getAttribute('href') || '', z));
    });

    // Suche: Feld und Leeren-Knopf
    var feld = w.querySelector('[data-mv-teile-suche]');
    if (feld && feld.value !== z.q && document.activeElement !== feld) feld.value = z.q;
    var leeren = w.querySelector('[data-mv-teile-suche-leeren]');
    if (leeren) leeren.hidden = !z.q;
  }

  function urlSchreiben(s) {
    if (!window.history || typeof window.history.replaceState !== 'function') return;
    var jetzt = window.location.pathname + window.location.search + window.location.hash;
    var neu = urlMitZustand(jetzt, s.zustand);
    if (neu === jetzt) return;
    try {
      window.history.replaceState(window.history.state, '', neu);
    } catch (e) { /* ohne History-API bleibt die URL stehen */ }
  }

  function automatSetzen(s, automat) {
    s.zustand.automat = automat;
    speicherSetzen(automat);
    var merk = s.wurzel.querySelector('[data-mv-teile-merk]');
    if (merk && automat && !s.merkGezeigt) {
      merk.hidden = false;
      s.merkGezeigt = true;
    } else if (merk && !automat) {
      merk.hidden = true;
    }
  }

  // Weder das Element noch ein Vorfahr traegt hidden
  function ohneHidden(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentNode) if (n.hidden) return false;
    return true;
  }

  function fokussiere(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  // Paket T-1: Verschwindet der betaetigte Knopf mit seinem Filter, springt der Fokus auf den naechsten
  // Entfernen-Knopf der Auswahl-Leiste, sonst auf den Ergebnistitel (tabindex -1); bleibt er sichtbar, bleibt der Fokus.
  function fokusNachFilter(s, knopf) {
    if (!knopf || ohneHidden(knopf)) return;
    var knoepfe = alle('[data-mv-teile-auswahl] [data-mv-teile-weg]', s.wurzel);
    var i = fokusNachEntfernen(knoepfe.map(ohneHidden), knoepfe.indexOf(knopf));
    fokussiere(i >= 0 ? knoepfe[i] : s.wurzel.querySelector('[data-mv-teile-titel]'));
  }

  function ergebnisZeigen(s) {
    var ziel = s.wurzel.querySelector('[data-mv-teile-titel]') || s.wurzel.querySelector('[data-mv-teile-raster]');
    if (!ziel) return;
    if (typeof ziel.scrollIntoView === 'function') {
      try {
        ziel.scrollIntoView({ block: 'start', behavior: reduziert() ? 'auto' : 'smooth' });
      } catch (e) {
        ziel.scrollIntoView();
      }
    }
    if (typeof ziel.focus === 'function') {
      try {
        ziel.focus({ preventScroll: true });
      } catch (e) {
        ziel.focus();
      }
    }
  }

  function seiteStarten(wurzel) {
    var s = seiteLesen(wurzel);
    var gueltig = { familien: s.familien, karte: s.karte };
    var ausUrl = zustandAusSuche(window.location.search, gueltig);
    var startAutomat = attr(wurzel, 'data-mv-teile-start-automat');
    var startKategorie = attr(wurzel, 'data-mv-teile-start-kategorie');
    s.zustand.automat = ausUrl.automat || (s.familien.indexOf(startAutomat) !== -1 ? startAutomat : '');
    s.zustand.kategorie = ausUrl.kategorie || (kachelVon(startKategorie, s.karte) ? startKategorie : '');
    s.zustand.q = ausUrl.q;
    if (!s.zustand.automat && !s.gefiltert && parameter(window.location.search, 'automat') === null) {
      s.zustand.automat = speicherLesen(speicherHolen(), s.familien);
    }
    if (ausUrl.automat) speicherSetzen(ausUrl.automat);
    zeichnen(s);
    if (!s.gefiltert) urlSchreiben(s);
    wurzel.setAttribute('data-mv-teile-bereit', '');
    // Paket EP-3: Nummernsuche (mit ?q= beim Laden einmal)
    nummerStarten(s);
    return s;
  }

  function seiteZu(el) {
    var wurzel = el && el.closest ? el.closest('[data-mv-ersatzteile]') : null;
    if (!wurzel) return null;
    for (var i = 0; i < seiten.length; i++) if (seiten[i].wurzel === wurzel) return seiten[i];
    return null;
  }

  function seitenStarten() {
    // Paket EP-3: laufende Nummernsuchen der alten Fassung (Theme-Editor, bfcache) abbrechen
    seiten.forEach(function (s) { nummerAbbrechen(s.nummer); });
    seiten = alle('[data-mv-ersatzteile]').map(seiteStarten);
  }

  document.addEventListener('click', function (e) {
    var ziel = e.target && e.target.closest ? e.target : null;
    if (!ziel) return;
    var s = seiteZu(ziel);
    if (!s) return;

    var chip = ziel.closest('[data-mv-teile-automat]');
    if (chip && !s.gefiltert && abfangen(e)) {
      e.preventDefault();
      var f = attr(chip, 'data-mv-teile-automat');
      if (f && s.familien.indexOf(f) === -1) return;
      automatSetzen(s, f);
      zeichnen(s);
      urlSchreiben(s);
      return;
    }

    var kachel = ziel.closest('a[data-mv-teile-kategorie]');
    if (kachel && !s.gefiltert && abfangen(e)) {
      e.preventDefault();
      var key = attr(kachel, 'data-mv-teile-kategorie');
      s.zustand.kategorie = kachelVon(s.zustand.kategorie, s.karte) === key ? '' : key;
      zeichnen(s);
      urlSchreiben(s);
      if (s.zustand.kategorie) ergebnisZeigen(s);
      return;
    }

    var weg = ziel.closest('[data-mv-teile-weg]');
    if (weg) {
      e.preventDefault();
      var art = attr(weg, 'data-mv-teile-weg');
      if (art === 'automat') automatSetzen(s, '');
      else if (art === 'kategorie') s.zustand.kategorie = '';
      else if (art === 'q') s.zustand.q = '';
      zeichnen(s);
      urlSchreiben(s);
      fokusNachFilter(s, weg);
      nummerSuchen(s, s.zustand.q);
      return;
    }

    var zurueck = ziel.closest('[data-mv-teile-zuruecksetzen]');
    if (zurueck) {
      e.preventDefault();
      automatSetzen(s, '');
      s.zustand.kategorie = '';
      s.zustand.q = '';
      var feld0 = s.wurzel.querySelector('[data-mv-teile-suche]');
      if (feld0) feld0.value = '';
      zeichnen(s);
      urlSchreiben(s);
      fokusNachFilter(s, zurueck);
      nummerSuchen(s, '');
      return;
    }

    if (ziel.closest('[data-mv-teile-suche-leeren]')) {
      e.preventDefault();
      s.zustand.q = '';
      var feld = s.wurzel.querySelector('[data-mv-teile-suche]');
      if (feld) {
        feld.value = '';
        feld.focus();
      }
      zeichnen(s);
      urlSchreiben(s);
      nummerSuchen(s, '');
    }
  });

  document.addEventListener('input', function (e) {
    var feld = e.target && e.target.closest ? e.target.closest('[data-mv-teile-suche]') : null;
    if (!feld) return;
    var s = seiteZu(feld);
    if (!s) return;
    if (s.timer) window.clearTimeout(s.timer);
    s.timer = window.setTimeout(function () {
      s.timer = null;
      s.zustand.q = String(feld.value || '').replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, MAX_SUCHE);
      zeichnen(s);
      urlSchreiben(s);
    }, 180);
    // Paket EP-3: Nummernsuche entprellt (350 ms nach der letzten Eingabe)
    nummerPlanen(s, feld.value);
  });

  document.addEventListener('keydown', function (e) {
    var feld = e.target && e.target.closest ? e.target.closest('[data-mv-teile-suche]') : null;
    if (!feld) return;
    var s = seiteZu(feld);
    if (!s) return;
    if (e.key === 'Escape' && feld.value) {
      e.preventDefault();
      feld.value = '';
      s.zustand.q = '';
      zeichnen(s);
      urlSchreiben(s);
      nummerSuchen(s, '');
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (s.timer) {
        window.clearTimeout(s.timer);
        s.timer = null;
      }
      s.zustand.q = String(feld.value || '').replace(/\s+/g, ' ').replace(/^ | $/g, '').slice(0, MAX_SUCHE);
      zeichnen(s);
      urlSchreiben(s);
      ergebnisZeigen(s);
      nummerSuchen(s, feld.value);
    }
  });

  // ---------- 2. Bestell-Eigenschaften ----------

  var gemerkt = {};

  function felderVon(gruppe) {
    return alle('[data-mv-eig-name]', gruppe);
  }

  function fehlerElement(feld) {
    var box = feld.closest('[data-mv-eig-feld]');
    return box ? box.querySelector('[data-mv-eig-fehler]') : null;
  }

  function beschreibungSetzen(feld, id, an) {
    var ids = liste(feld.getAttribute('aria-describedby')).filter(function (x) { return x !== id; });
    if (an) ids.push(id);
    if (ids.length) feld.setAttribute('aria-describedby', ids.join(' '));
    else feld.removeAttribute('aria-describedby');
  }

  function fehlerZeigen(feld) {
    var p = fehlerElement(feld);
    feld.setAttribute('aria-invalid', 'true');
    if (p) {
      p.hidden = false;
      if (p.id) beschreibungSetzen(feld, p.id, true);
    }
  }

  function fehlerWeg(feld) {
    var p = fehlerElement(feld);
    feld.removeAttribute('aria-invalid');
    if (p) {
      p.hidden = true;
      if (p.id) beschreibungSetzen(feld, p.id, false);
    }
  }

  function optionTexte(select) {
    return Array.prototype.slice.call(select.options).filter(function (o) { return o.value !== ''; }).map(function (o) { return o.value; });
  }

  function wertSetzen(feld, wert, ausLink) {
    if (feld.tagName === 'SELECT') {
      var optionen = Array.prototype.slice.call(feld.options).filter(function (o) { return o.value !== ''; });
      var i = optionIndex(optionTexte(feld), wert);
      if (i !== -1) {
        feld.value = optionen[i].value;
      } else {
        var o = document.createElement('option');
        o.value = wert;
        o.textContent = ausLink ? wert + TEXT.ausLink : wert;
        o.setAttribute('data-mv-eig-url', '');
        feld.appendChild(o);
        feld.value = wert;
      }
      return true;
    }
    var max = parseInt(feld.getAttribute('maxlength'), 10) || MAX_WERT;
    feld.value = String(wert).slice(0, max);
    return true;
  }

  function merken(feld) {
    var gruppe = feld.closest('[data-mv-eigenschaften]');
    if (!gruppe) return;
    var form = attr(gruppe, 'data-mv-eigenschaften');
    gemerkt[form] = gemerkt[form] || {};
    gemerkt[form][attr(feld, 'data-mv-eig-name')] = feld.value;
  }

  function eigenschaftenStarten(gruppe) {
    if (gruppe.hasAttribute('data-mv-eig-bereit')) return;
    gruppe.setAttribute('data-mv-eig-bereit', '');
    var form = attr(gruppe, 'data-mv-eigenschaften');
    var ausUrl = eigenschaftenAusSuche(window.location.search);
    var vorbelegt = false;
    felderVon(gruppe).forEach(function (feld) {
      var name = attr(feld, 'data-mv-eig-name');
      var alt = gemerkt[form] && Object.prototype.hasOwnProperty.call(gemerkt[form], name) ? gemerkt[form][name] : null;
      if (alt) {
        wertSetzen(feld, alt, false);
        return;
      }
      for (var i = 0; i < ausUrl.length; i++) {
        if (nameGleich(ausUrl[i].name, name)) {
          wertSetzen(feld, ausUrl[i].wert, true);
          vorbelegt = true;
          merken(feld);
          break;
        }
      }
    });
    var hinweis = gruppe.querySelector('[data-mv-eig-vorbelegt]');
    if (hinweis && vorbelegt) hinweis.hidden = false;
  }

  function eigenschaftenAlle() {
    alle('[data-mv-eigenschaften]').forEach(eigenschaftenStarten);
  }

  var fokusGeplant = false;
  document.addEventListener('invalid', function (e) {
    var feld = e.target && e.target.closest ? e.target.closest('[data-mv-eig-name]') : null;
    if (!feld) return;
    e.preventDefault();
    fehlerZeigen(feld);
    if (fokusGeplant) return;
    fokusGeplant = true;
    window.setTimeout(function () {
      fokusGeplant = false;
      var erstes = alle('[data-mv-eig-name][aria-invalid="true"]')[0];
      if (erstes && typeof erstes.focus === 'function') erstes.focus();
    }, 0);
  }, true);

  function eingabe(e) {
    var feld = e.target && e.target.closest ? e.target.closest('[data-mv-eig-name]') : null;
    if (!feld) return;
    merken(feld);
    if (typeof feld.checkValidity !== 'function' || feld.checkValidity()) fehlerWeg(feld);
  }
  document.addEventListener('change', eingabe);
  document.addEventListener('input', eingabe);

  // Impact rendert die Kaufbox beim Produktwechsel neu: danach die gemerkten Werte wieder eintragen
  document.addEventListener('product:rerender', function () {
    window.setTimeout(eigenschaftenAlle, 0);
  }, true);

  // ---------- 3. Nummernsuche (Paket EP-3) ----------

  var nummernSpeicher = nummerSpeicher(NUMMER.speicher);
  var nummerGewarnt = false;

  // Hoechstens einmal je Seite eine Warnung in der Konsole (Route fehlt, Fehler); keine Anzeige fuer Kunden
  function nummerWarnen(fehler) {
    if (nummerGewarnt) return;
    nummerGewarnt = true;
    try {
      if (window.console && typeof window.console.warn === 'function') window.console.warn('mv-sortiment.teile: Nummernsuche ohne Antwort', fehler && fehler.message ? fehler.message : String(fehler));
    } catch (e) { /* ohne Konsole */ }
  }

  function nummerFeld(wurzel, name) {
    return wurzel.querySelector('[data-mv-nummer-feld="' + name + '"]');
  }

  function entfernen(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  // Zugaenglicher Name eines Knopfs: sein Text und das Teil ("Teil anfragen: <Bezeichnung>")
  function knopfName(el, name) {
    var text = einzeilig(el.textContent);
    if (text && name) el.setAttribute('aria-label', text + ': ' + name);
  }

  // Karte eines Treffers aus der Liquid-Vorlage: nur textContent und Attribute
  function nummerKarte(vorlage, t, stand) {
    var quelle = vorlage.content ? vorlage.content.firstElementChild : null;
    if (!quelle) return null;
    var li = document.importNode(quelle, true);
    var karte = li.querySelector('[data-mv-nummer-treffer]');
    if (karte) karte.setAttribute('data-mv-nummer-treffer', t.nr);
    var nr = nummerFeld(li, 'nr');
    if (nr) nr.textContent = t.nr;
    var name = t.shop && t.shop.titel ? t.shop.titel : t.bezeichnung;
    var titel = nummerFeld(li, 'titel');
    if (titel) {
      titel.setAttribute('title', t.liste);
      if (t.shop) {
        var link = document.createElement('a');
        link.className = 'mv-card__link';
        link.setAttribute('href', '/products/' + t.shop.handle);
        link.textContent = name;
        titel.appendChild(link);
      } else {
        titel.textContent = name;
      }
    }
    if (t.netto !== null) {
      var netto = nummerFeld(li, 'netto');
      if (netto) netto.textContent = euro(t.netto);
      var brutto = nummerFeld(li, 'brutto');
      if (t.brutto !== null && brutto) brutto.textContent = euro(t.brutto);
      else entfernen(nummerFeld(li, 'brutto-zeile'));
      entfernen(nummerFeld(li, 'ohne-preis'));
    } else {
      entfernen(nummerFeld(li, 'preis'));
    }
    var standEl = nummerFeld(li, 'stand');
    if (t.netto !== null && stand && standEl) standEl.textContent = stand;
    else entfernen(nummerFeld(li, 'stand-pille'));
    var anfrage = nummerFeld(li, 'anfrage');
    var produkt = nummerFeld(li, 'produkt');
    var produktAnfrage = nummerFeld(li, 'produkt-anfrage');
    if (t.shop) {
      var ziel = t.shop.status === 'anfrage' ? produktAnfrage : produkt;
      entfernen(anfrage);
      entfernen(ziel === produkt ? produktAnfrage : produkt);
      if (ziel) {
        ziel.setAttribute('href', '/products/' + t.shop.handle);
        knopfName(ziel, name);
      }
    } else {
      entfernen(produkt);
      entfernen(produktAnfrage);
      if (anfrage) {
        var teil = anfrageTeil(t.nr, t.bezeichnung, t.netto);
        anfrage.setAttribute('data-teil', teil);
        anfrage.setAttribute('href', anfrageHref(teil));
        knopfName(anfrage, name);
      }
    }
    return li;
  }

  // Ansage fuer Screenreader: Live-Region [data-mv-nummer-ansage] steht ausserhalb der verborgenen Gruppe (eine Region,
  // die erst mit ihrem Inhalt sichtbar wird, liest kein Screenreader vor); Text = Titel und Zaehler der Gruppe ohne den
  // Suchbegriff ([data-mv-nummer-anzahl], sonst der ganze Status), '' beim Verbergen (dann wird auch eine gleichlautende
  // naechste Ansage wieder vorgelesen)
  function nummerAnsage(s, an) {
    var el = s.nummer && s.nummer.ansage;
    if (!el) return;
    var g = s.nummer.gruppe;
    var titel = an && g ? g.querySelector('[data-mv-nummer-titel]') : null;
    var zaehler = an && g ? g.querySelector('[data-mv-nummer-anzahl]') || g.querySelector('[data-mv-nummer-status]') : null;
    el.textContent = an ? einzeilig((titel ? titel.textContent + ': ' : '') + (zaehler ? zaehler.textContent : '')) : '';
  }

  // Gruppe mit der Antwort fuellen und zeigen; false ohne Raster oder Vorlage (dann verborgen)
  function nummerZeichnen(s, a) {
    var g = s.nummer.gruppe;
    var raster = g.querySelector('[data-mv-nummer-raster]');
    var vorlage = g.querySelector('template[data-mv-nummer-karte]');
    if (!raster || !vorlage || !vorlage.content) {
      g.hidden = true;
      nummerAnsage(s, false);
      return false;
    }
    while (raster.firstChild) raster.removeChild(raster.firstChild);
    for (var i = 0; i < a.treffer.length; i++) {
      var li = nummerKarte(vorlage, a.treffer[i], a.stand);
      if (li) raster.appendChild(li);
    }
    var n = raster.children.length;
    raster.hidden = n === 0;
    zahlSetzen(g.querySelector('[data-mv-nummer-zahl]'), n + a.weitere);
    // Suchbegriff im Kopf ("N Treffer fuer <q>"): die gesendete Eingabe, nur als Text
    var frage = g.querySelector('[data-mv-nummer-q]');
    if (frage) frage.textContent = s.nummer.q;
    var weitere = g.querySelector('[data-mv-nummer-weitere]');
    if (weitere) {
      weitere.hidden = !(n > 0 && a.weitere > 0);
      zahlSetzen(weitere.querySelector('[data-mv-nummer-weitere-zahl]'), a.weitere);
    }
    var leer = g.querySelector('[data-mv-nummer-leer]');
    if (leer) leer.hidden = n > 0;
    g.hidden = false;
    nummerAnsage(s, true);
    return true;
  }

  function nummerAbbrechen(n) {
    if (!n) return;
    if (n.timer) {
      window.clearTimeout(n.timer);
      n.timer = null;
    }
    if (n.ctrl) {
      try {
        n.ctrl.abort();
      } catch (e) { /* schon beendet */ }
      n.ctrl = null;
    }
    n.wartet = false;
    // spaete Antworten frueherer Anfragen verwerfen
    n.lauf += 1;
  }

  function nummerStarten(s) {
    var gruppe = s.wurzel.querySelector('[data-mv-nummer-gruppe]');
    s.nummer = { gruppe: gruppe, ansage: s.wurzel.querySelector('[data-mv-nummer-ansage]'), timer: null, ctrl: null, wartet: false, lauf: 0, q: '', danach: null };
    if (gruppe && s.zustand.q) nummerSuchen(s, s.zustand.q);
  }

  function nummerFertig(s, a) {
    var n = s.nummer;
    n.ctrl = null;
    n.wartet = false;
    var ok = nummerZeichnen(s, a);
    var danach = n.danach;
    n.danach = null;
    if (danach) danach(ok);
  }

  function nummerFehler(s, fehler) {
    var n = s.nummer;
    n.ctrl = null;
    n.wartet = false;
    n.q = '';
    n.gruppe.hidden = true;
    nummerAnsage(s, false);
    nummerWarnen(fehler);
    var danach = n.danach;
    n.danach = null;
    if (danach) danach(false);
  }

  // Entprellt suchen (350 ms nach der letzten Eingabe)
  function nummerPlanen(s, eingabe) {
    var n = s.nummer;
    if (!n || !n.gruppe) return;
    if (n.timer) window.clearTimeout(n.timer);
    n.timer = window.setTimeout(function () {
      n.timer = null;
      nummerSuchen(s, eingabe);
    }, NUMMER.pause);
  }

  // Sofort suchen: Eingabe ausserhalb von 3 bis 60 Zeichen verbirgt die Gruppe; dieselbe Eingabe fragt nicht erneut;
  // die Antwort kommt aus dem Speicher oder von der Route (die laufende Anfrage wird abgebrochen). danach(ok) laeuft,
  // sobald die Gruppe gezeichnet (true) oder verborgen (false) ist.
  function nummerSuchen(s, eingabe, danach) {
    var n = s.nummer;
    if (!n || !n.gruppe) {
      if (danach) danach(false);
      return;
    }
    if (n.timer) {
      window.clearTimeout(n.timer);
      n.timer = null;
    }
    var q = nummerFrage(eingabe);
    if (!q) {
      nummerAbbrechen(n);
      n.q = '';
      n.danach = null;
      n.gruppe.hidden = true;
      nummerAnsage(s, false);
      if (danach) danach(false);
      return;
    }
    if (q === n.q) {
      if (n.wartet) {
        if (danach) n.danach = danach;
      } else if (danach) {
        danach(!n.gruppe.hidden);
      }
      return;
    }
    nummerAbbrechen(n);
    n.q = q;
    n.danach = danach || null;
    var vorhanden = nummernSpeicher.hole(q);
    if (vorhanden) {
      nummerFertig(s, vorhanden);
      return;
    }
    if (typeof window.fetch !== 'function' || typeof window.Promise !== 'function') {
      nummerFehler(s, new Error('fetch fehlt'));
      return;
    }
    var lauf = n.lauf;
    var ctrl = null;
    try {
      ctrl = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    } catch (e) {
      ctrl = null;
    }
    var opt = { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (ctrl) opt.signal = ctrl.signal;
    n.ctrl = ctrl;
    n.wartet = true;
    var anfrage;
    try {
      anfrage = window.fetch(nummerUrl(n.gruppe.getAttribute('data-mv-nummer-basis'), q), opt);
    } catch (e) {
      anfrage = window.Promise.reject(e);
    }
    window.Promise.resolve(anfrage).then(function (r) {
      if (!r || r.status !== 200 || typeof r.json !== 'function') throw new Error('HTTP ' + (r && r.status ? r.status : '-'));
      return r.json();
    }).then(function (json) {
      if (lauf !== n.lauf) return;
      var a = antwortAus(json);
      if (!a) throw new Error('Antwort ohne ok');
      nummernSpeicher.lege(q, a);
      nummerFertig(s, a);
    }).catch(function (fehler) {
      if (lauf !== n.lauf) return;
      if (fehler && fehler.name === 'AbortError') return;
      nummerFehler(s, fehler);
    });
  }

  // Nach dem Formular im Band: Gruppe in den Blick, Fokus auf den Gruppenkopf (tabindex -1)
  function nummerZeigen(s) {
    var g = s.nummer && s.nummer.gruppe;
    if (!g || g.hidden) return;
    if (typeof g.scrollIntoView === 'function') {
      try {
        g.scrollIntoView({ block: 'start', behavior: reduziert() ? 'auto' : 'smooth' });
      } catch (e) {
        g.scrollIntoView();
      }
    }
    fokussiere(g.querySelector('[data-mv-nummer-titel]'));
  }

  // Formular "Ersatzteil suchen" im Band: mit Skript Suchfeld und Kartenfilter setzen (URL-Vertrag ?q=), sofort suchen,
  // danach zur Gruppe; ohne Skript fuehrt es auf ?q= dieser Kollektion
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-mv-nummer-form]') : null;
    if (!form) return;
    var s = seiteZu(form);
    if (!s || !s.nummer || !s.nummer.gruppe) return;
    e.preventDefault();
    var eingabe = form.querySelector('input[name="q"]');
    var q = nummerFrage(eingabe ? eingabe.value : '');
    if (!q) {
      fokussiere(eingabe);
      return;
    }
    var feld = s.wurzel.querySelector('[data-mv-teile-suche]');
    if (feld) feld.value = q;
    if (s.timer) {
      window.clearTimeout(s.timer);
      s.timer = null;
    }
    s.zustand.q = q.slice(0, MAX_SUCHE);
    zeichnen(s);
    urlSchreiben(s);
    nummerSuchen(s, q, function (ok) {
      if (ok) nummerZeigen(s);
      else ergebnisZeigen(s);
    });
  });

  // ---------- Start ----------

  function starten() {
    seitenStarten();
    eigenschaftenAlle();
  }

  document.addEventListener('shopify:section:load', starten);
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) starten();
  });

  MV.teile = {
    version: VERSION,
    logik: logik,
    init: starten,
    zustand: function () {
      return seiten.map(function (s) {
        return { automat: s.zustand.automat, kategorie: s.zustand.kategorie, q: s.zustand.q };
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
})();
